// Context for sharing total Languages among components
import React from "react";

export default React.createContext([]);
